export default function($) {
  $(document).ready(function(){
    // @see https://github.com/xdan/datetimepicker
    // @see https://xdsoft.net/jqplugins/datetimepicker/
    $.datetimepicker.setLocale('en');

    $('.js-datetime-picker').datetimepicker({
      format: 'Y-m-d H:i:s',
      inline: true,
    });

    $('.js-date-picker').datetimepicker({
      timepicker:false,
      format: 'Y-m-d',
    });

    $('.js-plane-datetime-picker').datetimepicker({
      format: 'Y-m-d H:i:s',
      inline: true,
      startDate: '2020-05-01 00:00:01',
      endDate: '2020-05-31 23:59:59',
    });
  });
}
